import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useLocation } from "react-router";

import * as Api from "@/api";
import { setDrawerOpen } from "@/store/reducers/ui";
import Valkyrie from "@sippy-platform/valkyrie";

import { ListItem, ListItemButton, ListItemIcon, ListItemText, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

function NavigationItem({ title, link, alt = [], exact = false, selected, ...props }) {
  const theme = useTheme();
  const matchesLgDown = useMediaQuery(theme.breakpoints.down("lg"));
  const location = useLocation();
  const dispatch = useDispatch();

  const isActive = useMemo(() => {
    if (selected) {
      return true;
    }

    if (exact) {
      return location?.pathname === `/${link}`;
    } else {
      return [link, ...alt].map((url) => location?.pathname?.startsWith(`/${url}`)).includes(true);
    }
  }, [selected, exact, location?.pathname, link, alt]);

  function onNavigate() {
    Api.cancelActiveGetRequests();

    if (matchesLgDown) {
      dispatch(setDrawerOpen(false));
    }
  }

  return (
    <ListItem disablePadding id={`menu-${link.replace(/\//g, "-")}`}>
      <ListItemButton component={NavLink} selected={isActive} to={`/${link}`} onClick={onNavigate}>
        <ListItemIcon>
          <Valkyrie icon={props.icon} />
        </ListItemIcon>
        <ListItemText primary={title} />
      </ListItemButton>
    </ListItem>
  );
}

NavigationItem.propTypes = {
  link: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.object,
  alt: PropTypes.array,
  exact: PropTypes.bool,
  selected: PropTypes.bool,
};

export default NavigationItem;
